
import React from 'react';
import { Leaf, BarChart3 } from 'lucide-react';

const RSEHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-fabre-green via-fabre-teal to-fabre-darkteal text-white py-20 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-32 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-full p-4">
              <Leaf className="w-12 h-12 text-white" />
            </div>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6 leading-tight">
            Prestation RSE
          </h1>
          
          <div className="w-24 h-1.5 bg-white/30 mx-auto mb-8 rounded-full"></div>
          
          <p className="text-xl md:text-2xl opacity-90 leading-relaxed mb-8">
            Accompagnement global pour une gestion responsable et durable de vos déchets
          </p>

          {/* Stats rapides */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <BarChart3 className="w-8 h-8 text-white mx-auto mb-3" />
              <div className="text-2xl font-bold">25+</div>
              <div className="text-sm opacity-80">Années d'expertise</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <Leaf className="w-8 h-8 text-white mx-auto mb-3" />
              <div className="text-2xl font-bold">95%</div>
              <div className="text-sm opacity-80">Taux valorisation</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RSEHero;
